export default __webpack_public_path__ + "static/media/c002-1.bb28f75b.png";